export var es = {
    required: 'Requerido',
    deprecated: 'Obsoleto',
    deprecated_and_sunset_on: 'Esta operación está obsoleta y se retirará el ${1}.',
    stability_experimental: 'Experimental',
    stability_alpha: 'Alfa',
    stability_beta: 'Beta',
    copy_to_clipboard: 'Copiar al portapapeles',
    copied: 'Copiado',
    no_content: 'Sin contenido',
    unresolved_reference: 'Referencia no resuelta',
    circular_reference: 'Referencia circular',
    read_only: 'Solo lectura',
    write_only: 'Solo escritura',
    optional: 'Opcional',
    min: 'Mín',
    max: 'Máx',
    nullable: 'Nulo',
    body: 'Cuerpo',
    payload: 'Caga útil',
    headers: 'Encabezados',
    authorizations: 'Autorizaciones',
    responses: 'Respuestas',
    path_parameters: 'Parámetros de ruta',
    query_parameters: 'Parámetros de consulta',
    header_parameters: 'Parámetros de encabezado',
    attributes: 'Atributos',
    test_it: 'Pruébalo',
    information: 'Información',
    success: 'Éxito',
    redirect: 'Redirección',
    error: 'Error',
    show: 'Mostrar',
    hide: 'Ocultar',
    available_items: 'Elementos disponibles',
    child_attributes: 'Atributos secundarios',
};
